/**
 * DownloadButton — triggers a Blob download of the Markdown as a .md file.
 */

import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

interface DownloadButtonProps {
  markdown: string;
  filename: string;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  markdown,
  filename,
}) => {
  const { t } = useTranslation();
  const baseName = filename.replace(/\.pdf$/i, "");

  const handleDownload = useCallback(() => {
    const blob = new Blob([markdown], { type: "text/markdown;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `${baseName}.md`;
    anchor.click();

    URL.revokeObjectURL(url);
  }, [markdown, baseName]);

  return (
    <button className="btn btn--secondary" onClick={handleDownload}>
      {t("actions.download")}
    </button>
  );
};
